<!--
 * @Author: chenmengnan
 * @Date:  2024-06-11 16:53:27
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-12-26 14:45:25
 * @Description: 数据管理
 * @FilePath: \web\src\components\DataManagement\roleManagement\roleManagement.vue
-->
<template>
  <div class="role-management-wrap">

    <div class="role-management-main">
      <div class="search-container">

        <div class="search">
          <div class="search-item">
            <div class="search-item-text">角色名称：</div>
            <a-input class="user-name-input" v-model:value="requestParams.roleName" />
          </div>
          <!-- 组织机构 -->
          <div class="btn-wrapper">
            <div class="reset-btn btn-item" @click="resetSearch">重置</div>
            <div class="search-btn btn-item" @click="submitSearch()">查询</div>
          </div>
        </div>

        <div class="crud-wrapper" v-if="operationConf.includes(config.getPermissionId())">
          <div class="crud-item" @click="add()">新增</div>
        </div>
      </div>

      <a-table rowKey="id" class="management-table" :dataSource="roleList" :loading="userPagesLoading"
        :columns="columns" @change="changePage" :scroll="{ y: '90%' }" :pagination="false">
        <template #serial="{ index }">{{ index + 1 }}</template>

        <template #sysRoleList="{ record }">
          {{ userRole(record) }}
        </template>

        <template #action="{ record }">
          <section class="action-icons">
            <i v-for="(item, index) in tableOperationList" :key="index" v-bind="item.option"
              @click="item.click(record)">
            </i>
          </section>
        </template>
      </a-table>

      <Modal :option="confirmModalConf" @confirm="confirm" @close="close">
        <template v-slot:main>

          <AddUser v-if="confirmModalConf.modalType === 'add' || confirmModalConf.modalType === 'edit'"
            :modalType="confirmModalConf.modalType" :formState="formState" ref="formRef" />
        </template>
      </Modal>
      <!-- / 操作弹出框 -->
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, toRefs, onBeforeMount, } from 'vue';
import { useStore, } from 'vuex';
import Modal from '@/components/lib/Modal/modal1.vue';
import { GET_ROLE_LIST, GET_USER_LIST_PAGE, } from '@/store/modules/actions/roleManagement';
import { userRoleAllocateApi, addRoleApi, editRoleApi, deleteRoleApi, getRoleListApi } from '@/api/dataManagement/roleManagement';
import config from '@/config/config';
import tableConfig from './tableConfig.js';
import AddUser from './add.vue';

const columns = tableConfig;


const { state, dispatch: storeDispatch, commit: storeCommit, } = useStore();
// state
const userManagementState = computed(() => state.roleManagement);
const { userPages, totalCount, userPagesLoading, } = toRefs(
  userManagementState.value
);
// 重写commit
const commit = (space, methods, params) => storeCommit(`${space || 'roleManagement'}/${methods}`, params);
// 重写dispatch
const dispatch = (space, methods, params) => storeDispatch(`${space || 'roleManagement'}/${methods}`, params);

const orgTree = ref([]); // 组织机构数据
const requestParams = reactive({
  roleName: '',
  page: 1,
  size: 8, order: 'asc',
})

// 确认弹窗 公用
const confirmModalConf = reactive({
  loading: false,
  visible: false,
  title: '',
  confirm: null,
  remark: '',
  callback: null,
  showRemark: true,
  selectValue: [],
  modalType: '',
  sysRoleIdList: [],
});

let formState = ref({
});
const mineralIds = ref([]);

let psdFormState = ref({});

let orgFormState = ref({});
const orgFormRef = ref();
const formRef = ref();
const psdRef = ref();

const userRole = (record) => {
  const ll = [];

  if (record.sysRoleList) {
    record.sysRoleList.forEach(item => ll.push(item.description));
  }

  return ll.toString();
};
const roleList = ref([]);
const getTable = () => {
  getRoleListApi(requestParams).then(res => {
    roleList.value = res.data;
  });
}
/**
 * @description 检索查询事件
 */
const submitSearch = () => {
  // dispatch(null, GET_ROLE_LIST);
  requestParams.page = 1;
  requestParams.size = 8
  getTable()
};

/**
 * @description 检索重置事件
 */
const resetSearch = () => {
  commit(null, 'clear');
  requestParams.roleName = ''
  submitSearch();
};



/* 获取角色数据 */
const getRoleList = () => {
  // dispatch(null, GET_ROLE_LIST);
};

/**
 * @description 页码change事件
 */
const changePage = (page) => {
  // commit(null, 'setRequestParams', { page: page.current, size: page.pageSize, });
  requestParams.page = page.current
  requestParams.size = page.pageSize
  getTable();
};

/**
 * @description 关闭通用弹窗
 */
const close = () => {
  confirmModalConf.remark = '';
  confirmModalConf.visible = false;
  if (confirmModalConf.modalType) {
    formState.value = {};
    psdFormState.value = {};
    orgFormState.value = {};
    formRef.value.userForm.resetFields();
    psdRef.value.psdResetForm.resetFields();
    orgFormRef.value.orgForm.resetFields();
  }
};

/**
 * @description 确认通用弹窗
 */
const confirm = () => {
  confirmModalConf.callback();
};

// -------------------- 删除
/**
 * @description 删除项目
 */
const delUser = (id) => {
  // const requestData = ids.map((i) => ({ id: i, remark: confirmModalConf.remark, }));

  deleteRoleApi([id]).then((res) => {
    confirmModalConf.visible = false;
    confirmModalConf.title = '';
    // getRoleList();
    submitSearch();
  });
};

/**
 * @description 删除项目之前
 */
const beforeDel = (id) => {
  confirmModalConf.showRemark = true;
  confirmModalConf.title = '确认删除角色？';
  confirmModalConf.callback = () => delUser(id);
  confirmModalConf.visible = true;
  confirmModalConf.width = '6rem';
  confirmModalConf.modalType = '';
};

/**
 * @description 单行数据删除
 */
const delRecord = (record) => {
  const { roleId, } = record;

  beforeDel(roleId);
};


/* 编辑 */
const editUser = (record) => {
  formRef.value.userForm.validate().then(() => {
    editRoleApi(formState.value).then(res => {
      confirmModalConf.visible = false;
      confirmModalConf.title = '';
      confirmModalConf.modalType = '';
      formState.value = {};
      submitSearch();
    });
  }).catch(info => {
    console.log('Validate Failed:', info);
  });
};
const editecord = (record) => {
  let rr = record;

  formState.value = JSON.parse(JSON.stringify(rr));
  confirmModalConf.modalType = 'edit';
  confirmModalConf.title = '修改角色';
  confirmModalConf.callback = () => editUser(rr);
  confirmModalConf.visible = true;
  confirmModalConf.width = '6rem';
};
/**
 * @description 新增
 */
const addData = () => {
  formRef.value.userForm.validate().then(() => {
    console.log(formState.value)
    addRoleApi(formState.value).then(res => {
      confirmModalConf.visible = false;
      confirmModalConf.title = '';
      confirmModalConf.modalType = '';
      formState.value = {};
      submitSearch();
    });
  }).catch(info => {
    console.log('Validate Failed:', info);
  });
};
const add = () => {
  confirmModalConf.modalType = 'add';
  confirmModalConf.visible = true;
  confirmModalConf.title = '新增角色';
  confirmModalConf.width = '6rem';
  confirmModalConf.callback = () => addData();
};

/* 用户角色修改 */
const roleEdit = (record) => {
  let list = [];

  confirmModalConf.sysRoleIdList.forEach(item => {
    list.push({
      id: null,
      roleId: item,
      userId: record.userId,
    });
  });
  if (list.length > 0) {
    userRoleAllocateApi(list).then(res => {
      confirmModalConf.visible = false;
      confirmModalConf.title = '';
      confirmModalConf.modalType = '';
      submitSearch();
    });
  }
};

const tableOperationList = ref([]);
// 新增 删除的权限控制
const operationConf = [1,];

// 操作的权限
const tableOperationListConf = [
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-bianjishuru',
      title: '编辑',
    },
    click: editecord,
    operation: [1,],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-shanchu',
      title: '删除',
    },
    click: delRecord,
    operation: [1,],
  },
];

onBeforeMount(() => {
  tableOperationList.value = tableOperationListConf.filter((i) => i.operation.includes(config.getPermissionId()));
  // getOrgTree();
  // searchHandle();
  submitSearch()
  // getRoleList();
});

</script>

<style lang="scss">
.role-management-wrap {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  background: rgba(179, 150, 92, 0.05);

  .role-management-main {
    height: 100%;
    width: 100%;
    background: rgba(179, 150, 92, 0.05);

    /* 检索条件 */
    .search-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: .1rem;
      height: 0.5rem;
      margin-bottom: 0.1rem;

      .search {
        display: flex;

        .search-item {
          width: 2.2rem;
          height: 0.34rem;
          margin-right: 0.05rem;
          display: flex;

          .search-item-text {
            color: #fff;
            width: 1.1rem;
            text-align: right;
            height: 0.34rem;
            line-height: 0.34rem;
          }
        }

        /* 重置、查询操作 */
        .btn-wrapper {
          height: 0.32rem;
          line-height: 0.32rem;
          margin-left: 0.2rem;
          color: #ffffff;
          display: flex;
          padding: 0;

          .btn-item {
            width: 0.9rem;
            text-align: center;
            cursor: pointer;

            &:active {
              opacity: 0.8;
            }
          }

          .reset-btn {
            // background-color: #535962;
            background-image: url(~@/static/images/dataManagement/reset_btn.png);
            background-size: 100% 100%;
          }

          .search-btn {
            margin-left: 0.05rem;
            // background-color: #efb227;
            background-image: url(~@/static/images/dataManagement/submit_btn.png);
            background-size: 100% 100%;
          }
        }

        /* 输入框 */
        .ant-input {
          color: white;
          background-color: rgba(91, 76, 39, 0.4);
          font-size: 0.14rem;
          font-family: Microsoft YaHei;
          border: transparent;
        }

        .ant-input-suffix {
          width: 0.12rem;
          height: 0.12rem;
          margin-top: .02rem;
        }

        /** 下拉框 */
        .ant-select {
          width: 100%;
          height: 100%;

          .ant-select-selector {
            height: 100%;
          }

          .ant-select-arrow {
            color: #fff;
          }

          .ant-select-selection-item {
            line-height: .34rem;
          }

          // 背景
          &:not(.ant-select-customize-input) .ant-select-selector {
            background-color: rgba(91, 76, 39, 0.4);
            border: none;
            color: #fff;
          }

          /* 描述 */
          .ant-select-selection-placeholder {
            line-height: .34rem;
            color: #fff;
          }
        }
      }

      /* 增删改导按钮 */
      .crud-wrapper {
        display: flex;
        height: 0.51rem;
        padding: 0.13rem 0.1rem;

        .crud-item {
          margin-right: 0.04rem;
          width: 0.5rem;
          line-height: .25rem;
          color: #fff;
          // background-color: #efb227;
          background-image: url(~@/static/images/dataManagement/curd_btn.png);
          background-size: 100% 100%;
          text-align: center;
        }

        .crud-item:hover {
          cursor: pointer;
        }

        .crud-item-disabled {
          pointer-events: none;
          color: rgba(255, 255, 255, 0.6);
          // background-color: rgba(239, 178, 39, 0.6);
          opacity: 0.8;
        }

        .crud-item-disabled:hover {
          cursor: no-drop;
        }
      }
    }

    /* 矿种图标 */
    .minerals-img {
      width: 0.6rem;
      height: 0.3rem;
    }

    /* 表格样式 */
    .management-table {
      height: calc(100% - 0.5rem);

      .ant-spin-container {
        display: flex;
        flex-direction: column;
        align-items: end;
      }

      .ant-spin-nested-loading,
      .ant-spin-container,
      .ant-table-content {
        height: 100%;
      }

      .ant-table {
        height: calc(100% - .70rem);
        background: none;
        padding-left: 0.1rem;

        .ant-table-scroll {
          height: 100%;
          overflow: visible;
          overflow-x: visible;

          .ant-table-header {
            overflow: visible !important;
            margin-bottom: 0 !important;
          }
        }

        .ant-table-header {
          background: none;
        }

        .ant-table-body {
          overflow-x: hidden !important;
          overflow-y: auto !important;
          background: none;
        }

        /* 矿种 */
        .primary-commodity-img {
          width: 0.8rem;
          height: 0.6rem;
        }

        /* 图标 */
        .action-icons {
          i {
            font-size: 0.22rem;
            margin-right: 0.04rem;
            cursor: pointer;
          }
        }

        .ant-table-thead {
          border: .01rem solid #4d3f1c;
          border-radius: .10rem .10rem 0rem 0rem;
          background: none;
        }

        .ant-table-thead>tr>th {
          color: #dccdab;
          background: rgba(179, 150, 92, 0.2);
          border: none;
        }

        .ant-table-tbody>tr>td {
          background-color: transparent;
          color: #fff;
          border-bottom: .01rem solid rgba(179, 150, 92, 1);
          vertical-align: middle;
        }

        .ant-table-placeholder {
          height: 100%;
          background-color: rgba(77, 63, 28, 1);
          border-top: rgba(179, 150, 92, 1);
          border-bottom: rgba(179, 150, 92, 1);
        }

        .ant-empty-normal {
          color: rgba(179, 150, 92, 1);
        }

        // 暂无数据填充样式
        // .ant-empty-img-simple-path {
        //   fill: rgba(77, 63, 28, 1);
        // }
        // .ant-empty-img-simple-ellipse {
        //   fill: rgba(77, 63, 28, 1);
        // }
        .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
        .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
        .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
        .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
          background-color: rgba(179, 150, 92, 0.6);
        }

        .ant-table-thead>tr:hover.ant-table-row-selected>td,
        .ant-table-tbody>tr:hover.ant-table-row-selected>td {
          background-color: rgba(179, 150, 92, 0.6);
        }

        .ant-table-tbody>tr.ant-table-row-selected td {
          background-color: rgba(77, 63, 28, 1);
          color: #fff;
        }
      }
    }
  }
}
</style>